export default __webpack_public_path__ + "static/media/Teologia.b040b108.pdf";